export default __webpack_public_path__ + "static/media/Archer-Medium.8840b2f0.eot";